import gql from 'graphql-tag';
export const UI_GET_SEMESTERS = gql`
  query UI_GET_SEMESTERS {
    semesters {
      name
      order
      classCount
      earliestDate
      latestDate
    }
  }
`;
export const UI_GET_CURRICULA = gql`
  query UI_GET_CURRICULA {
    curricula {
      id
      name
      subname
      accessible
      iconURL
      url
      color
      gradeRangeName
    }
  }
`;
export const UI_GET_GRADE_LIST = gql`
  query UI_GET_GRADE_LIST {
    grades {
      position
      name
      id
    }
  }
`;
export const UI_GET_AGE_GROUPS = gql`
  query UI_GET_AGE_GROUPS {
    ageGroups {
      id
      name
      from
      to
    }
  }
`;